module.exports = __webpack_public_path__ + "img/data_download.9cb8123b.gif";